import React, { Dispatch } from "react";

import { NavLink } from "react-router-dom";

import styles from "./sidebarnavlink.module.scss";

import SidebarMenuItemType from "../enums/SidebarMenuItemType";
import { IconProp } from "@fortawesome/fontawesome-svg-core";
import { Accordion } from "react-bootstrap";
import SidebarMenuItem from "../models/SidebarMenuItem";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { setSidebarShow, SidebarAction } from "infrastructure/store/sidebar/SidebarActions";
import SidebarState from "infrastructure/store/sidebar/SidebarState";
import IAppState from "infrastructure/store/IAppState";
import Icon from "features/shared/components/icons/Icon";
import { getDynamicConfig } from "infrastructure/configuration/configurationHelper";
import { isMultipleLangs } from "features/shared/helpers/languageHelper";

const dynamicConfig = getDynamicConfig();

interface IProps {
  menuItem: SidebarMenuItem
}

const SidebarNavLink: React.FC<IProps> = (props) => {
  // props destruct
  const { id, title, icon, routePath, type, url, urlInNewTab = true } = props.menuItem;

  // translations
  const { i18n } = useTranslation();
  const { t } = useTranslation("shared\\moduleNames");
  const tLinks = useTranslation("shared\\components").t;

  // store
  const sidebarDispatch = useDispatch<Dispatch<SidebarAction>>();
  const sidebarShow = useSelector<IAppState, SidebarState>((store) => store.sidebar).sidebarShow;

  // helpers
  const getUrl = () => { 
    let linkUrl = url;

    if (type == SidebarMenuItemType.DynamicLink && url) {
      linkUrl = dynamicConfig.sidebarLinks[url];

      if (isMultipleLangs() && linkUrl) {
        let urlObj = new URL(linkUrl);
        urlObj.searchParams.set('lng', i18n.language);
        linkUrl = urlObj.toString();
      }
    }

    return linkUrl;
  }

  // handlers
  const hideSidebarHandler = () => {
    // hide sidebar only on mobile devices
    // 768px = default bootstrap md breakpoint
    if (!window.matchMedia("(min-width: 768px)").matches) {
      sidebarDispatch(setSidebarShow(!sidebarShow));
      // remove disabling page scroll on mobile devices
      document.body.classList.remove("overflow-hidden");
    }
  }

  // render
  switch (type) {
    case SidebarMenuItemType.Route:
      return (
        <Accordion.Toggle as="div" eventKey={id}>
          <NavLink
            to={routePath!}
            exact={routePath === "/"}
            className={styles.sidebarMainLink}
            activeClassName={styles.sidebarLinkActive}
            onClick={hideSidebarHandler}
          >
            <span className={styles.sidebarLinkIcon}>
              <Icon icon={icon as IconProp} />
            </span>
            <span className={styles.sidebarLinkText}>{t(title)}</span>
          </NavLink>
        </Accordion.Toggle>
      );
    case SidebarMenuItemType.Link:
    case SidebarMenuItemType.DynamicLink:
      return (
        <a href={getUrl()} target={urlInNewTab ? "_blank" : undefined} className={styles.sidebarMainLink}>
          <span className={styles.sidebarLinkIcon}>
              <Icon icon={icon!} />
            </span>
            <span className={styles.sidebarLinkText}>
              {tLinks(`sidebarNavCard.links.${title}`)}
            </span>
        </a>
      );
    default:
      return null;
  }
};

export default SidebarNavLink;
